import React from 'react'
import ClassNames from 'classnames'
import TextLink from 'Atoms/TextLink'
import FeaturedArticle from '../FeaturedArticle'
import Typography from 'Atoms/Typography'
import List from 'Molecules/List'
import Image from 'next/image'
import Svg from 'Atoms/Svg'
import Skeleton from 'Atoms/Skeleton'
import Event from 'Utilities/Event'
import ArticleCard from 'Containers/ArticleCard'

import styles from './Toolbox.module.scss'
import SkeletonContent from '../../../Containers/SkeletonContent'

const ToolboxBladeEvent = label => Event({
    category: 'Header',
    action: 'Toolbox Blade clicked',
    label,
})

const ToolboxContent = ({
    recommendedArticles,
    tech,
    builds,
    news,
    featuredArticle
}) => {
    let featuredTitle = "Featured Article"
    return (
        <>
            <div className={styles.toolboxContent}>
                <div className={styles.mainContent}>
                    <div className={ClassNames(styles.toolboxFeaturedArticleSection, recommendedArticles?.length >= 1 ? styles.recommendationsEnabled : null)}>

                        <Typography
                            className={ClassNames(styles.toolBoxMenuTitle, styles.featuredArticleTitle)}
                            href={featuredArticle?.url}
                            onClick={() => ToolboxBladeEvent(featuredTitle)()}
                            size={1.25}
                            tone={'contrast'}
                            font={'heading'}
                            as={'a'}
                        >
                            {featuredTitle}
                        </Typography>

                        <div className={ClassNames(styles.featuredArticleWrapper, recommendedArticles?.length >= 1 ? styles.recommendationsEnabled : null)}>
                            <ArticleCard article={featuredArticle} useButton />
                        </div>

                        <a
                            className={styles.seeAllArticlesSection}
                            href={'/the-toolbox'}
                            onClick={() => ToolboxBladeEvent({
                                label: "See All Toolbox Articles Clicked"
                            })()}
                        >
                            <Typography
                                className={styles.seeMoreText}
                                intent={'action'}
                            >
                                See All Toolbox Articles
                            </Typography>
                            <Svg size={1} icon={'chevron'} intent={'action'} />
                        </a>

                    </div>
                    <ToolboxMenuSection title={'Tech'} options={tech} href={'/the-toolbox/tech~2-1'} className={styles.techTipsSection} />
                    <ToolboxMenuSection title={'Builds'} options={builds} className={styles.buildsSection} />
                    <ToolboxMenuSection title={'News'} options={news} href={'/the-toolbox/news~2-3'} className={styles.newsSection} />
                    <div className={styles.mediaContentSection}>
                        <MediaContent
                            title={'Videos'}
                            content={{
                                imageUrl:
                                    'https://content.speedwaymotors.com/ToolboxImages/VideoRepresentative.jpg',
                                href: '/the-toolbox/videos~2-2'
                            }}
                        />
                        <MediaContent
                            title={'Podcasts'}
                            content={{
                                imageUrl:
                                    'https://content.speedwaymotors.com/ToolboxImages/PodcastRepresentative.jpg',
                                href:
                                    '/the-toolbox/what-moves-you-podcast~512-156'
                            }}
                        />
                    </div>
                </div>
                {recommendedArticles?.length >= 1 && <RecommendedContent recommendedArticles={recommendedArticles} />}
            </div>
        </>
    )
}

const RecommendedContent = ({ recommendedArticles }) => {
    if (!recommendedArticles || recommendedArticles?.length <= 0) {
        return false
    }

    let title = 'Recommended Articles For You'
    return (
        <>

            <Typography
                className={ClassNames(styles.toolBoxMenuTitle, styles.recommendedArticlesTitle)}
                size={1.25}
                tone={'contrast'}
                font={'heading'}
                as={'a'}
                href={'/the-toolbox/recommended'}
                onClick={() => ToolboxBladeEvent(title)()}
            >
                {title}
            </Typography>

            <div className={styles.recommendedArticles}>

                {recommendedArticles?.map((article) => {
                    const { articleDetails } = article
                    if (articleDetails) {
                        return (
                            <div key={article.articleId}
                                className={styles.marginWrapper}
                                onClick={() => {
                                    ToolboxBladeEvent("Recommended Article")()
                                }}
                            >
                                <div className={styles.recommendedArticleCardWrapper}>
                                    <ArticleCard article={articleDetails} horizontal />
                                </div>
                            </div>
                        )
                    }
                })}
            </div>
        </>
    )
}

const MediaContent = ({ title, content }) => {
    if (!content) {
        return (
            <>
                <Typography
                    className={styles.mediaContentSectionTitle}
                    size={1.25}
                    tone={'contrast'}
                    font={'heading'}
                >
                    {title}
                </Typography>
                <Skeleton width={300} height={185} />
            </>
        )
    }

    const { imageUrl, href } = content

    return (
        <div>
            <div>
                <Typography
                    className={styles.mediaContentSectionTitle}
                    size={1.25}
                    tone={'contrast'}
                    font={'heading'}
                    as={'a'}
                    href={href}
                    onClick={() => {
                        ToolboxBladeEvent(title)()
                    }}
                >
                    {title}
                </Typography>
            </div>


            <a href={href}>
                <Image
                    className={styles.mediaContentImage}
                    src={imageUrl}
                    width={300}
                    height={185}
                />
            </a>
        </div>


    )
}

const ToolboxMenuSection = ({ title, options, href, className }) => {
    let content = null
    if (!options) {
        content = (
            <SkeletonContent
                rows={8}
                skeletonProps={{
                    className: styles.toolboxOption,
                    height: 25,
                    fullWidth: true
                }}
            />
        )
    } else {
        content = (
            <List>
                {options?.map((option) => {
                    return (

                        <TextLink
                            size={0.875}
                            className={styles.toolboxOption}
                            as={'a'}
                            href={option.href} key={option.title}
                            onClick={() => {
                                ToolboxBladeEvent(option.title)()
                            }}
                        >
                            {option.title}
                        </TextLink>
                    )
                })}
            </List>
        )
    }

    return (
        <div className={ClassNames(styles.toolboxMenuSection, className)}>
            <Typography
                className={styles.toolBoxMenuTitle}
                size={1.25}
                tone={'contrast'}
                font={'heading'}
                as={href ? 'a' : undefined}
                href={href}
                onClick={() => {
                    ToolboxBladeEvent(title)()
                }}>
            {title}
                </Typography>
            {content}
        </div>
    )
}

export { ToolboxContent }
